
import './index.css';
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

console.log(`%c EchoScribe Environment `, 'background: #6366f1; color: white; padding: 4px; border-radius: 4px; font-weight: bold;');
console.log('Domain:', window.location.hostname);
console.log('Protocol:', window.location.protocol);
console.log('API Key Present:', !!process.env.API_KEY);

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error("Could not find root element to mount to");
}

const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
